<section class="heading-container">
  <h2><span>{{examType}}</span> College Predictor</h2>
  <p>Helping you decide the college of your Dreams</p>
  <div class="search-container">
    <div class="search-form-inline">
      <input type="text" placeholder="Search by College" #searchCollege/>
      <button class="btn btn-primary" (click)="searchCollegeName(searchCollege.value)">Search</button>
    </div>
  </div>
</section>

<section class="college-lisiting">
  <div class="container">
    <div class="filter-sortby-section">
        <div class="filter-section">
            <label>Filters</label>
            <div class="dropdown-container">
            <div class="dropdown">
                <button class="btn custom-dropdown dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span *ngIf="selectedCourse.length <= 3; else countSelectedCourseTpl">{{selectedCourse.join(' ,')|| DEFAULT_TITLE.COURSE}}</span>
                  <ng-template #countSelectedCourseTpl>{{selectedCourse.length}} items selected</ng-template>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <input type="text" placeholder="Search the courses" class="form-control search-box" (input)="searchCourse($event)"/>
                    <ul class="pl-0 mb-0">
                      <li class="dropdown-item" *ngFor="let course of courses">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="{{course.name}}" [value]="course.name" (input)="selectCourse($event,course.name)" />
                          <label class="form-check-label" for="msc">{{course.name}}</label>
                        </div>
                      </li>
                  </ul>
                </div>
              </div>
              <div class="dropdown">
                <button class="btn custom-dropdown dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span *ngIf="selectedLocation.length <= 3; else countSelectedLocationTpl">{{selectedLocation.join(' ,')|| DEFAULT_TITLE.LOCATION}}</span>
                    <ng-template #countSelectedLocationTpl>{{selectedLocation.length}} items selected</ng-template> 
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <input type="text" placeholder="Search Location" class="form-control search-box" (input)="searchLocation($event)"/>
                    <ul class="pl-0 mb-0">
                      <li class="dropdown-item" *ngFor="let location of locations">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="{{location.name}}" [value]="location.name" (input)="selectLocation($event,location.name)">
                          <label class="form-check-label" [for]="location.name">{{location.name}}</label>
                        </div>
                      </li>
                  </ul>
                </div>
              </div>
              <div class="dropdown">
                <button class="btn custom-dropdown dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span>{{selectedBranch.join(' ,') || DEFAULT_TITLE.BRANCH}}</span>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <input type="text" placeholder="Select Preferred Branches" class="form-control search-box"  (input)="searchBranch($event)"/>
                    <ul class="pl-0 mb-0">
                      <li class="dropdown-item" [ngClass]="{'disabled': selectedBranch.length >= 3 && !selectedBranch.includes(branch.name)}" *ngFor="let branch of branches">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input"  id="{{branch.name}}"  [checked]="selectedBranch.includes(branch.name)" (input)="selectBranch($event,branch.name)">
                          <label class="form-check-label" [for]="branch.name">{{branch.name}}</label>
                        </div>
                      </li>
                  </ul>
                </div>
              </div>
            </div>
        </div>
        <div class="sort-by-container">
            <label>Sort by</label>
            <div class="dropdown">
                <button class="btn custom-dropdown dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Chances : {{sortType}}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" (click)="applySort(DEFAULT_TITLE.HIGH_TO_LOW)">Chances: {{DEFAULT_TITLE.HIGH_TO_LOW}}</a>
                  <a class="dropdown-item" (click)="applySort(DEFAULT_TITLE.LOW_TO_HIGH)">Chances: {{DEFAULT_TITLE.LOW_TO_HIGH}}</a>
                  <a class="dropdown-item" (click)="applySort(DEFAULT_TITLE.HIGH_TO_LOW_RANK)">Closing Rank: {{DEFAULT_TITLE.HIGH_TO_LOW_RANK}}</a>
                  <a class="dropdown-item" (click)="applySort(DEFAULT_TITLE.LOW_TO_HIGH_RANK)">Closing Rank: {{DEFAULT_TITLE.LOW_TO_HIGH_RANK}}</a>
                </div>
              </div>
        </div>
    </div>
    <div class="college-list">
        <ul *ngIf="(collegesList | collegeFilter :searchValue ).length; else emptyListTpl">
            <li *ngFor="let college of (collegesList | collegeFilter :searchValue )">
                <div>
                    <div class="batch-tags">
                        <span></span>
                        Best Match
                    </div>
                    <div class="chances-tag">
                        Chances: <span class="high">{{college.chance}}</span>
                    </div>
                </div>
                <div class="college-img">
                    <img [src]="college.imageUrl || DEFAULT_TITLE.COLLEGE_IMG" alt="college-building"/>
                </div>
                <div class="college-content">
                    <div class="college-logo">
                        <img [alt]="college.collegeName" [src]="college.logo"/>
                    </div>
                    <h2>{{college.collegeName}}</h2>
                    <h3>{{college.branch}}</h3>
                    <h3>{{college.courseType}}</h3>
                </div>
                <div class="college-rank">
                    Closing Rank 2018: <span>{{college.closingRank}}</span>
                </div>
            </li>
        </ul>
        <ng-template #emptyListTpl>
          <div class="empty-state">
            <img src="/assets/img/s3-images/picasso/no-college-data.svg"/>
            <b>No College Found!!</b>
          </div>
        </ng-template>
    </div>
    <p *ngIf="collegesList.length" class="disclaimer-text"><b>Disclaimer:</b> The result displayed is based on the data and trends of the previous years collected over years. It must be used only as a reference since it may differ from the current year’s actual result.</p>
  </div>
</section>
